"use client";

import { createContext } from "react";
import type Lenis from "lenis";

export const LenisContext = createContext<Lenis | null>(null);

/** Fired by the hero once its entrance choreography no longer needs a locked viewport. */
export const INTRO_COMPLETE_EVENT = "quikit:intro-complete";

/** Seconds the loader wordmark rests on screen before the hero stage rises over it. */
export const INTRO_HOLD = 0.5;

/** Total length of the whole intro (loader + hero entrance), in seconds. The timeline is scaled to fit. */
export const INTRO_TOTAL = 3;
